import { z } from "zod";
import { FeedLensSchema } from "@/features/discovery/index.contract.ts";
import { FindSearchSchema } from "./find-route.contract.ts";

export const DoomscrollSearchSchema = FindSearchSchema.extend({
    source: z
        .enum(["adopt", "explore", "find", "feed"])
        .optional()
        .catch(undefined),
    lens: FeedLensSchema.optional().catch(undefined),
});

export type DoomscrollSearch = z.infer<typeof DoomscrollSearchSchema>;
